import dedent from 'dedent';
import { z } from 'zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP, zodTDateISODate } from '~/lib/zod';
import { layoutSchema } from '~/tenants/bre/performable/print/design/BreDesignConfig';

export type PostcardMailingSize = z.infer<typeof sizeSchema>;

export type PostcardMailingPaper = z.infer<typeof paperSchema>;

export type PostcardMailingPostage = z.infer<typeof postageSchema>;

export type PostcardAnnouncementType = z.infer<typeof announcementType>;

export const sizeSchema = z.enum(['half', 'jumbo', 'flats']);

export const paperSchema = z.enum(['heavy_gloss']);

export const postageSchema = z.enum(['standard', 'first_class']);

export const announcementType = z.enum(['just_listed', 'sold', 'other']);

export default createPerformableConfig(
  'postcards-mailing',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      count: z.coerce
        .number({ invalid_type_error: 'Count is required' })
        .min(250, { message: 'Count must be at least 250 pieces' })
        .max(7000, { message: 'Count cannot be over 7000 pieces' }),
      size: sizeSchema,
      paper: paperSchema,
      postage: postageSchema,
      announcement_type: announcementType,
      need_by: zodTDateISODate('Need By date is required'),
      design: layoutSchema.optional(),
    }),
  },
  {
    name: 'Post Cards (mailing)',
    group: 'Property Marketing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/print/postcards/mailing/thumbnail_v2.jpg',
    images: [],
    short: dedent`
      Our custom postcards are a great way to market your listings and engage your \
      community. Whether for a Just Listed, Just Sold, or other announcement, we create \
      eye-catching designs tailored to your brand. Available in half-sheet (5.5" x 8.5") \
      or jumbo (6" x 11") sizes, with addressing and mailing fees included, reaching your \
      target audience is hassle-free.
    `,
  },
);
